/** @jsx jsx */
import { Box, jsx } from 'theme-ui'
import React from 'react'
import { Link } from 'gatsby'

export const FooterList = () => {
  const sections = [
    {
      title: 'サービス',
      items: [
        { label: 'ホーム', to: '/' },
        { label: '案件・求人を探す', to: '/project-list' },
        { label: 'フリーランス入門ガイド', to: '/freelance-start' },
        { label: 'エンジビズの特徴', to: '/features' },
        { label: '無料個別カウンセリング', to: '/consultation' },
        { label: '単価診断', to: '/diagnosis' },
        { label: 'エンジニア市場価値診断', to: '/value-check' },
        { label: '手取りシミュレーター', to: '/tools/tax-simulator' },
        { label: '精算幅計算ツール', to: '/tools/settlement-calculator' },
        { label: '請求書作成ツール', to: '/tools/invoice-generator' },
        { label: 'コーディネーター紹介', to: '/coordinator' },
      ],
    },
    {
      title: 'リソース',
      items: [
        { label: 'お役立ちコンテンツ', to: '/blog-details' },
        { label: 'IT用語集', to: '/glossary' },
        { label: '執筆者一覧', to: '/writers' },
        { label: 'エンジニアインタビュー', to: '/interview-user' },
        { label: '企業インタビュー', to: '/interview-company' },
        { label: 'スキルシート対策', to: '/skill-sheet' },
        { label: 'メディア掲載実績・プレスリリース', to: '/press' }, // 第三者評価の提示で信頼度向上
      ],
    },
    {
      title: '企業・提携',
      items: [
        { label: '人材をお探しの企業様', to: '/for-companies' },
        { label: 'パートナー企業・協業企業', to: '/partners' },
      ],
    },
    {
      title: 'サポート',
      items: [
        { label: 'お問い合わせ（総合問い合わせ）', to: '/contact' },
        { label: 'エンジニアお問い合わせ', to: '/contact-engineer' },
        { label: '企業様お問い合わせ', to: '/contact-company' },
        { label: 'FAQよくある質問', to: '/faq' },
      ],
    },
    {
      title: '会社情報・法務',
      items: [
        { label: 'お知らせ', to: '/news' },
        // { label: 'サイトマップ', to: '#' }, // was: '/sitemap'
        {
          label: 'セキュリティ・コンプライアンス表示',
          to: '/security-compliance',
        }, // 準備中（信頼性向上のため掲示）（ISMS, Pマーク 等）
        { label: '運営会社', to: 'https://ukmeta.jp' },
      ],
    },
  ]

  return (
    <Box
      sx={{
        backgroundColor: '#333',
        color: 'white',
        padding: ['40px 16px', '40px 40px'],
        fontSize: ['13px', '15px'],
        width: '100vw',
        marginLeft: 'calc(50% - 50vw)',
        marginRight: 'calc(50% - 50vw)',
        boxSizing: 'border-box',
      }}
    >
      {/* Top row: service logo (left) and operator logo (right) */}
      <Box
        sx={{
          maxWidth: '1120px',
          margin: '0 auto 28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingBottom: '20px',
          borderBottom: '1px solid rgba(255,255,255,0.15)',
        }}
      >
        <Link to="/" sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            src="/new_logo_white.png"
            alt="engibiz logo"
            sx={{
              height: ['40px', '52px', '60px'],
              width: 'auto',
              display: 'block',
            }}
            loading="lazy"
            decoding="async"
          />
        </Link>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <span
            sx={{ fontSize: ['12px', '13px'], color: 'rgba(255,255,255,0.9)' }}
          >
            運営会社
          </span>
          <a
            href="https://ukmeta.jp"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              opacity: 1,
              transition: 'opacity .2s ease',
              '&:hover': { opacity: 0.85 },
            }}
          >
            <img
              src="/ukmeta.png"
              alt="UKMETA"
              sx={{
                height: ['18px', '22px', '26px'],
                width: 'auto',
                display: 'block',
              }}
              loading="lazy"
              decoding="async"
            />
          </a>
        </Box>
      </Box>

      {/* Link sections */}
      <Box sx={{ maxWidth: '1120px', margin: '0 auto' }}>
        {sections.map((section, index) => (
          <Box key={index} sx={{ marginBottom: '24px' }}>
            <h3
              sx={{
                fontSize: ['18px', '20px', '22px'],
                color: '#fff',
                marginBottom: '20px',
              }}
            >
              {section.title}
            </h3>
            <ul
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                maxWidth: '100%',
                gap: '12px 20px',
                padding: 0,
                margin: 0,
              }}
            >
              {section.items.map((item, i) => (
                <li
                  key={i}
                  style={{
                    display: 'block',
                    color: '#fff',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.to.startsWith('http') ? (
                    <a
                      href={item.to}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        fontSize: ['13px', '15px'],
                        color: '#fff',
                        textDecoration: 'none',
                        transition: 'color 0.2s ease',
                        '&:hover': { color: '#d1d5db' },
                      }}
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link
                      to={item.to}
                      sx={{
                        fontSize: ['13px', '15px'],
                        color: '#fff',
                        textDecoration: 'none',
                        transition: 'color 0.2s ease',
                        '&:hover': { color: '#d1d5db' },
                      }}
                    >
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
